export default __webpack_public_path__ + "3d91d261a225501f30ef57fa7fa1a933.png";